import {
  AUDIT_LOGS_CHANGE_CURRENT_PAGE ,
AUDIT_LOGS_CHANGE_ROWS_PER_PAGE ,
ADMIN_GET_FILTER_AUDIT_LOGS_REQUEST ,
ADMIN_GET_FILTER_AUDIT_LOGS_SUCCESS ,
GET_BY_ID_AUDIT_LOGS_REQUEST,
ADMIN_GET_FILTER_AUDIT_LOGS_ERROR ,
GET_BY_ID_AUDIT_LOGS_SUCCESS ,
SET_AUDIT_LOGS ,
SET_AUDIT_LOGS_FILTER_VALUE ,
AUDIT_LOGS_GET_BY_FACTORY_ID_REQUEST ,
AUDIT_LOGS_GET_BY_FACTORY_ID_SUCCESS ,
AUDIT_LOGS_GET_BY_FACTORY_ID_ERROR ,
} from '../actions/types'

const initialState = {
  loading: false,
  list: [],
  data: {},
  details: null,
  error: null,
  filter: null,
  countLogs:0,
  currentPage: 0,
  rowsPerPage: 10,
};

export default function auditLogsReducer(state = initialState, action) {
  switch (action.type) {
    case AUDIT_LOGS_CHANGE_CURRENT_PAGE:
      return {
        ...state,
        currentPage: action.payload,
      }; 
    case AUDIT_LOGS_CHANGE_ROWS_PER_PAGE:
      return {
        ...state,        
        rowsPerPage: action.payload
      };

    case ADMIN_GET_FILTER_AUDIT_LOGS_REQUEST:
      return {
        ...state,
        loading: true,
      }; 
      
    case ADMIN_GET_FILTER_AUDIT_LOGS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        list: action.payload.result,
        countLogs: action.payload.count || 0
      };
    case ADMIN_GET_FILTER_AUDIT_LOGS_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };

    case AUDIT_LOGS_GET_BY_FACTORY_ID_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case AUDIT_LOGS_GET_BY_FACTORY_ID_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        listDepartments: action.payload,
      };
    case AUDIT_LOGS_GET_BY_FACTORY_ID_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };


    case GET_BY_ID_AUDIT_LOGS_REQUEST:
      return { 
        ...state,
        isLoading: true,
        error: null,
        data: null,
      };
    case GET_BY_ID_AUDIT_LOGS_SUCCESS:
      return { 
        ...state,
        isLoading: false,
        error: null,
        data: action.payload,
      };
    case SET_AUDIT_LOGS:
      return {
        ...state,
        departmentDetails: action.payload,
      };

    case SET_AUDIT_LOGS_FILTER_VALUE:
        return {
          ...state,
          filter: action.payload
        };
    default:
      return state;
  }
}
